import styled, { css } from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Icon } from '@optimus-web/core';
import { LogItemVariant } from './LogItem';

const itemLineSpacing = getSpacingToken('200');
export const itemDefaultIconRadiusToken = '100';
const itemDefaultIconRadius = getSpacingToken(itemDefaultIconRadiusToken);
export const itemIconRadiusToken = '50';
const itemIconRadius = getSpacingToken(itemIconRadiusToken);

export const ActivityLogContainer = styled.ol`
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    flex-direction: column;
    gap: ${itemLineSpacing}px;
`;

export const ItemElement = styled.li`
    display: flex;
    gap: ${getSpacingToken('250')}px;
    align-items: stretch;
    box-sizing: border-box;
    background: transparent;
    border: 0;
    width: 100%;
    flex-direction: row;
    text-align: left;
`;

export const ItemTextWrapper = styled.div`
    overflow: auto;
    margin-bottom: ${getSpacingToken('250')}px;
    min-width: ${getSpacingToken('700')}px;

    ${MEDIA_QUERY.tabletUp} {
        display: block;
    }
`;

interface ItemIconElementProps {
    variant?: LogItemVariant;
}

export const ItemDefaultIconElement = styled.div<ItemIconElementProps>`
    width: ${getToken('sizing100')}px;
    height: ${getToken('sizing100')}px;
    border-radius: ${getToken('borderRadiusRound')};
    flex-shrink: 0;

    ${({ variant }) => {
        let backgroundColor;
        let boxShadowColor;
        switch (variant) {
            case 'success':
                backgroundColor = getToken('backgroundAlertSuccessPrimary');
                boxShadowColor = getToken('backgroundAlertSuccessSecondary');
                break;
            case 'warning':
                backgroundColor = getToken('backgroundAlertWarningPrimary');
                boxShadowColor = getToken('backgroundAlertWarningSecondary');
                break;

            case 'danger':
                backgroundColor = getToken('backgroundAlertDangerPrimary');
                boxShadowColor = getToken('backgroundAlertDangerSecondary');
                break;
            default:
                backgroundColor = getToken('backgroundAlertBasicPrimary');
                boxShadowColor = getToken('backgroundAlertBasicSecondary');
                break;
        }
        return css`
            background: ${backgroundColor};
            box-shadow: 0 0 0 ${itemDefaultIconRadius}px ${boxShadowColor};
        `;
    }}
`;

export const ItemIconElement = styled(Icon)<ItemIconElementProps>`
    border-radius: ${getToken('borderRadiusRound')};

    ${({ variant }) => {
        let backgroundColor;
        let boxShadowColor;
        switch (variant) {
            case 'success':
                backgroundColor = getToken('backgroundAlertSuccessSecondary');
                boxShadowColor = getToken('backgroundAlertSuccessSecondary');
                break;
            case 'warning':
                backgroundColor = getToken('backgroundAlertWarningSecondary');
                boxShadowColor = getToken('backgroundAlertWarningSecondary');
                break;
            case 'danger':
                backgroundColor = getToken('backgroundAlertDangerSecondary');
                boxShadowColor = getToken('backgroundAlertDangerSecondary');
                break;
            default:
                backgroundColor = getToken('backgroundAlertBasicSecondary');
                boxShadowColor = getToken('backgroundAlertBasicSecondary');
                break;
        }
        return css`
            background: ${backgroundColor};
            box-shadow: 0 0 0 ${itemIconRadius}px ${boxShadowColor};
        `;
    }}
`;

interface ItemLineElementProps {
    isDefaultIcon: boolean;
}

export const ItemLineElement = styled.div<ItemLineElementProps>`
    width: ${getToken('borderWidth150')}px;
    height: 100%;
    background: ${getToken('borderStaticPrimary')};
    border-radius: ${getToken('borderRadiusRound')}px;

    ${({ isDefaultIcon }) => {
        const iconRadius = isDefaultIcon ? itemDefaultIconRadius : itemIconRadius;
        return css`
            margin-top: calc((${iconRadius}px + ${itemLineSpacing}px));
        `;
    }}
`;
